type SqrlResolve<T> = (value: T | PromiseLike<T>) => void;
type SqrlReject<T> = (reason?: T) => void;
type SqrlPromise<T> = () => Promise<T>;

export interface QueuedPromise<T = any> {
  promise: SqrlPromise<T>;
  resolve: SqrlResolve<T>;
  reject: SqrlReject<T>;
}

export class Queue {
  static queue: QueuedPromise[] = [];
  static pendingPromise = false;

  static enqueue<T = void>(promise: SqrlPromise<T>): Promise<T> {
    return new Promise((resolve: SqrlResolve<T>, reject: SqrlReject<T>) => {
      this.queue.push({
        promise,
        resolve,
        reject,
      });
      this.dequeue();
    });
  }

  static dequeue(): boolean {
    if (this.pendingPromise) {
      return false;
    }
    const item = this.queue.shift();
    if (!item) {
      return false;
    }
    try {
      this.pendingPromise = true;
      item
        .promise()
        .then((value) => {
          this.pendingPromise = false;
          item.resolve(value);
          this.dequeue();
        })
        .catch((err) => {
          this.pendingPromise = false;
          item.reject(err);
          this.dequeue();
        });
    } catch (err) {
      this.pendingPromise = false;
      item.reject(err);
      this.dequeue();
    }
    return true;
  }
}
